// extracted by mini-css-extract-plugin
export default {"email-content":"EmailLink_email-content__nezik","email":"EmailLink_email__P+xs+","content-container-right":"EmailLink_content-container-right__yhjPv"};